/* TANVI product page: (1) phrase-aware Japanese line breaking for body copy (uses assets/budoux-ja.min.js)
   (2) mobile sticky buy bar that mirrors the real add-to-cart button. Loaded on product templates only. */
(function () {
  if (!document.body || !/\btemplate-product\b/.test(document.body.className)) return;

  // ---- (1) phrase-aware wrapping
  try {
    if (window.customElements && customElements.get('budoux-ja')) {
      var ps = document.querySelectorAll('.product__block__text:not([style*="color"]) > p');
      Array.prototype.forEach.call(ps, function (el) {
        if (el.getAttribute('data-phrase-wrap')) return;
        el.setAttribute('data-phrase-wrap', '1');
        var b = document.createElement('budoux-ja');
        while (el.firstChild) b.appendChild(el.firstChild);
        el.appendChild(b);
        while (b.firstChild) el.insertBefore(b.firstChild, b);
        el.removeChild(b);
        el.classList.add('tanvi-phrase'); // keep-all is applied by CSS on phones only
      });
    }
  } catch (e) {}

  // ---- (2) sticky buy bar (mobile; CSS hides it on wider screens)
  try {
    var real = document.querySelector('#MainContent .product__block__buttons [data-add-to-cart], #MainContent .btn--add-to-cart'); // main button only (related cards have their own)
    var titleEl = document.querySelector('#MainContent .product__title, #MainContent h1');
    if (!real || !('IntersectionObserver' in window)) return;

    var bar = document.createElement('div');
    bar.className = 'tanvi-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="tanvi-buybar__info"><div class="tanvi-buybar__title"></div><div class="tanvi-buybar__price"></div></div><button type="button" class="tanvi-buybar__btn"></button>';
    var tEl = bar.querySelector('.tanvi-buybar__title'), pEl = bar.querySelector('.tanvi-buybar__price'), btn = bar.querySelector('.tanvi-buybar__btn');
    tEl.textContent = titleEl ? titleEl.textContent.trim() : '';
    document.body.appendChild(bar);

    function sync() {
      var txt = real.querySelector('[data-add-to-cart-text]'), price = real.querySelector('[data-button-price]');
      btn.textContent = txt ? txt.textContent.trim() : real.textContent.trim();
      pEl.textContent = price ? price.textContent.trim() : '';
      btn.disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
    }
    sync();
    new MutationObserver(sync).observe(real, { subtree: true, childList: true, characterData: true, attributes: true });

    function needsChoice() {
      // any visible option the shopper must pick (variants / option apps) -> send them to the form instead of adding blindly
      var scope = real.closest('.product__content, .product__form__wrapper, #MainContent') || document;
      var inputs = scope.querySelectorAll('select, input[type="radio"], input[type="checkbox"], input[type="text"], textarea');
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        if (el.closest('.tanvi-buybar') || el.closest('[data-quantity-selector], .quantity__wrapper, .product__block__quantity')) continue;
        if (el.offsetParent !== null) return true;
      }
      return false;
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      if (needsChoice()) {
        real.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        real.click();
      }
    });

    var io = new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(real);
  } catch (e) {}
})();
